import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Mail, Phone, ExternalLink, Heart } from 'lucide-react';
import { companyInfo } from '../data/mock';
import { trackEmailClick, trackPhoneClick } from '../lib/metrikaGoals';
import MeetingPopup from './MeetingPopup';

const Footer = () => {
  const [meetingOpen, setMeetingOpen] = useState(false);

  return (
    <footer className="border-t border-border/50 bg-card/50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Company Info */}
          <div className="md:col-span-2">
            <p className="text-muted-foreground text-sm leading-relaxed max-w-md">
              Антология — поставщик лицензий и подписок на ПО для компаний
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-semibold mb-4 text-sm uppercase tracking-wider text-muted-foreground">Навигация</h4>
            <ul className="space-y-3">
              <li>
                <Link to="/solutions" className="text-sm text-foreground/80 hover:text-accent transition-colors">
                  Каталог решений
                </Link>
              </li>
              <li>
                <Link to="/gen-ai-creative" className="text-sm text-foreground/80 hover:text-accent transition-colors">
                  Gen AI для команд
                </Link>
              </li>
              <li>
                <Link to="/faq" className="text-sm text-foreground/80 hover:text-accent transition-colors">
                  FAQ
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-sm text-foreground/80 hover:text-accent transition-colors">
                  О компании
                </Link>
              </li>
              <li>
                <Link to="/novosti-antologia" className="text-sm text-foreground/80 hover:text-accent transition-colors">
                  Новости
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="font-semibold mb-4 text-sm uppercase tracking-wider text-muted-foreground">Контакты</h4>
            <ul className="space-y-3">
              <li>
                <a
                  href={`tel:${companyInfo.contact.phone.replace(/[^\d+]/g, '')}`}
                  onClick={trackPhoneClick}
                  className="flex items-center gap-2 text-sm text-foreground/80 hover:text-accent transition-colors"
                >
                  <Phone className="w-4 h-4" />
                  {companyInfo.contact.phone}
                </a>
              </li>
              <li>
                <a
                  href={`mailto:${companyInfo.contact.email}`}
                  onClick={trackEmailClick}
                  className="flex items-center gap-2 text-sm text-foreground/80 hover:text-accent transition-colors"
                >
                  <Mail className="w-4 h-4" />
                  {companyInfo.contact.email}
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-12 pt-8 border-t border-border/50">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-sm text-muted-foreground">
              © {new Date().getFullYear()}. Все права защищены.
            </p>
            <p className="text-xs text-muted-foreground/70 text-center md:text-left">
              ООО «Успенский Технологии» предоставляет услуги только для юридических лиц и индивидуальных предпринимателей
            </p>
            <div className="flex items-center gap-6">
              <a
                href="https://antologia.tech"
                target="_blank"
                rel="noopener noreferrer"
                className="text-sm text-muted-foreground hover:text-accent transition-colors flex items-center gap-1"
              >
                antologia.tech
                <ExternalLink className="w-3 h-3" />
              </a>
            <Link
              to="/privacy"
              className="text-sm text-muted-foreground hover:text-accent transition-colors"
            >
              Политика ПДн
            </Link>
            <Link
              to="/cookies"
              className="text-sm text-muted-foreground hover:text-accent transition-colors"
            >
              Cookies
            </Link>
            </div>
          </div>
          {/* Credits */}
          <div className="mt-6 flex justify-center items-center gap-2 text-sm text-muted-foreground">
            <Heart className="w-4 h-4 text-accent fill-accent" />
            <span>Сайт разработан и поддерживается с применением нейронных сетей</span>
          </div>
        </div>
      </div>
      <MeetingPopup open={meetingOpen} onOpenChange={setMeetingOpen} />
    </footer>
  );
};

export default Footer;
